import React from 'react'
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Upload from './pages/Upload/Upload';
// import MemberListReport from './pages/MemberListReport/MemberListReport';
import Layout from './Lyout';
import UsersTable from './components/UsersTableComponent';

const App = () =>{
  return (
    
    <BrowserRouter>
    <Layout/>
    {/* <UsersTable/> */}
       {/* <Routes> */}
         {/* <Route path='/' Component={Upload} /> */}
         {/* <Route path='/members-list' Component={MemberListReport} /> */}
       {/* </Routes> */}
    </BrowserRouter>
  )
}

export default App;